import React from "react";
import { TransformedDuration } from "./types";
import { ShiftComponent, TimesheetsShiftInfo } from "../../../types/Shift.types";
import { StyledTime } from "../styledComponents";
import { AttributesDisplay } from "../TimeColumnCell/AttributesDisplay";

export type AuditTimestampDurationDisplayProps = {
  edit: TransformedDuration;
  shiftInfo: TimesheetsShiftInfo;
  shiftKey: string;
};

export const AuditTimestampDurationDisplay = ({
  edit,
  shiftInfo,
  shiftKey,
} : AuditTimestampDurationDisplayProps) => {
  return <>
    <StyledTime>{`${edit.breakDurationMinutes} minutes`}</StyledTime>
    <AttributesDisplay
      attributes={edit.attributes}
      shiftInfo={shiftInfo}
      timeType={ShiftComponent.BREAK_DURATION}
      tooltipAnchor={`break-attribute-${shiftKey}`}
    />
  </>
};
